// extracted by mini-css-extract-plugin
export default {"declineView":"S1ic7gZ2YmcqB9C099G2","errGeneral":"DXgTs3rQiDT27Kde6E70"};